module.exports = __webpack_public_path__ + "img/cable-gray-sentosa.d568783c.svg";